// @flow
import React from 'react';
import { EditableInputField } from 'common/components/core/common/CustomEditableField';
import theme from 'common/components/core/table/PaginatedTableInputField.scss';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { compose } from 'recompose';
import { type PopoverPlaceEnumType } from 'common/components/core/popover/popOverFactory';

type Props = {
    original: Object,
    placeholder: string,
    column: Object,
    theme: Object,
    onSave: Function,
    onBulkSave?: Function,
    row: Object,
    defaultIsActive?: boolean,
    autoSaveOnOutsideClick?: boolean,
    clientId?: string,
    onEditViewChange?: (isActive: boolean) => void,
    enableBulkEditing?: boolean,
    onBulkSave?: (
        original: Object,
        updated: Object,
        accessor: Array<string> | string
    ) => void,
    popOverPosition?: PopoverPlaceEnumType
};

class PaginatedTableInputField extends React.PureComponent<Props> {
    handleOnSave = newValue => {
        const { column, original, onSave } = this.props;
        const { accessorString, editAccessor } = column;
        const updatedValue = editAccessor
            ? newValue.getIn(editAccessor.split('.'))
            : newValue;
        return onSave(
            original,
            updatedValue,
            editAccessor ? editAccessor : accessorString
        );
    };

    handleBulkSave = newValue => {
        const {
            column: { accessorString, editAccessor },
            original,
            onBulkSave
        } = this.props;
        const updatedValue = editAccessor
            ? newValue.getIn(editAccessor.split('.'))
            : newValue;
        return onBulkSave?.(
            original,
            updatedValue,
            editAccessor ? editAccessor : accessorString
        );
    };

    render() {
        const {
            column,
            theme,
            row,
            popOverPosition,
            enableBulkEditing,
            autoSaveOnOutsideClick,
            defaultIsActive = false
        } = this.props;
        const { placeholder, id } = column;
        const cellText = row[id] ?? '';

        return (
            <EditableInputField
                name={cellText}
                theme={theme}
                className={classnames(theme.editableInputField, {
                    [theme.placeholder]: !cellText
                })}
                placeholder={placeholder}
                customFieldClass={theme.customFieldContainer}
                type="text"
                value={cellText}
                onSave={this.handleOnSave}
                onBulkSave={this.handleBulkSave}
                isEditingEnabled
                autoSaveOnChange={false}
                disableEditIcon
                disableIcons={false}
                enableBulkEditing={enableBulkEditing}
                popOverPosition={popOverPosition}
                defaultIsActive={defaultIsActive}
                autoSaveOnOutsideClick={autoSaveOnOutsideClick}
            />
        );
    }
}

export default compose(themr('PaginatedTableInputField', theme))(
    PaginatedTableInputField
);
